import React from "react";
import { ArrowRight, ShieldCheck, Activity, FileHeart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourHealthcareAlly() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="31717" id="wake-up-refreshed" className="dark bg-background text-foreground relative overflow-hidden py-16 md:py-24 lg:py-32">
      {}
      <div className="absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-secondary/10 rounded-full blur-3xl opacity-50 pointer-events-none" />
      <div className="absolute bottom-0 right-0 translate-x-1/3 translate-y-1/3 w-[600px] h-[600px] bg-primary/10 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {}
          <div ref={ref} className={`lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4">
              <Badge variant="secondary" className="w-fit px-4 py-1.5 text-sm font-medium tracking-wide uppercase text-secondary bg-secondary/10 border-secondary/20 rounded-full">
                CPAP Alternatives
              </Badge>
              <h1 className="font-sans text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-primary leading-[1.1]">
                Wake Up Refreshed, <span className="italic text-foreground">Every Single Morning</span>
              </h1>
              <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
                Experience the gold standard in sleep apnea care. Our custom-fit oral 
                appliances provide a comfortable, quiet alternative to CPAP, helping 
                you breathe naturally and reclaim your vitality.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Button asChild size="lg" className="h-14 px-8 text-base rounded-full bg-secondary text-secondary-foreground shadow-lg shadow-secondary/20 hover:shadow-secondary/30 hover:bg-secondary/90 transition-all">
                <Link to="#">
                  Book Free Consultation
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base rounded-full border-primary/20 text-primary hover:bg-primary/5 hover:text-primary hover:border-primary/40 bg-transparent">
                <Link to="/OralAppliancesPage">Watch How It Works</Link>
              </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 border-t border-border/60 mt-4">
              {[{
              icon: ShieldCheck,
              label: "FDA Cleared",
              desc: "Expertly designed"
            }, {
              icon: Activity,
              label: "Custom Fit",
              desc: "Maximum comfort"
            }, {
              icon: FileHeart,
              label: "Insurance Ready",
              desc: "Coverage assistance"
            }].map((item, i) => <div key={i} data-index={i} className="flex items-start gap-3">
                  <div className="p-2 rounded-lg bg-secondary/10 text-secondary">
                    <item.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="font-bold text-foreground text-sm">
                      {item.label}
                    </h3>
                    <p className="text-sm text-muted-foreground">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative group perspective-1000">
            <div className={`relative z-10 transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0 rotate-0" : "opacity-0 translate-x-10 rotate-1"}`}>
              {}
              <div className="relative rounded-tl-[60px] rounded-br-[60px] rounded-tr-2xl rounded-bl-2xl overflow-hidden shadow-2xl shadow-primary/10 border border-white/10 bg-muted">
                <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent opacity-60 mix-blend-multiply z-10 pointer-events-none" />
                <img src="https://asleepdentist.com/wp-content/uploads/2026/04/image.webp" alt="A rested patient waking up refreshed after using oral appliance therapy" className="w-full h-[500px] lg:h-[650px] object-cover object-center transform transition-transform duration-700 group-hover:scale-105" />
              </div>

              {}
              <div className="absolute -bottom-6 -left-6 md:bottom-8 md:-left-12 z-20 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-700 fill-mode-forwards opacity-0">
                <div className="bg-card/95 backdrop-blur-md border border-border/50 p-5 rounded-xl shadow-xl flex items-center gap-4 max-w-[280px]">
                  <div className="h-12 w-12 rounded-full bg-secondary/10 flex items-center justify-center shrink-0 text-secondary">
                    <ShieldCheck className="h-6 w-6" />
                  </div>
                  <div>
                    <p className="font-sans text-lg font-bold text-foreground leading-tight">
                      Dr. Ryan Miller
                    </p>
                    <p className="text-xs font-sans font-bold text-secondary uppercase tracking-wider mt-0.5">
                      Sleep Dentist
                    </p>
                    <p className="text-xs text-muted-foreground mt-1">
                      Board Certified
                    </p>
                  </div>
                </div>
              </div>

              {}
              <div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-secondary/30 rounded-tr-[30px] -z-10" />
              <div className="absolute -bottom-4 -left-4 w-24 h-24 border-b-2 border-l-2 border-secondary/30 rounded-bl-[30px] -z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}